/* eslint-disable complexity, max-statements, no-underscore-dangle */
(function init() {
  // Important: This file will not be transpiled / minified, so make sure the syntax works in all supported browsers.
  // App Dynamics Key & Beacon urls
  window.emui = window.emui || {};
  // asset path is parent folder of current script file
  window.emui._ASSET_PATH = new URL('../', document.currentScript.src).href;
  window.emui._BASE_PATH = new URL(document.baseURI).pathname;
  // Point the LogRocket CDN at the current env, from the host frame referrer or,
  // if that misses, the CDN this app was served from (_ASSET_PATH). No match
  // keeps pui-logrocket's default.
  try {
    const cdnEnvMatch =
      (document.referrer || '').match(/mortgagetech\.([a-z0-9]+)\.ice\.com/i) ||
      (window.emui._ASSET_PATH || '').match(
        /mortgagetech\.([a-z0-9]+)\.ice\.com/i,
      );
    if (cdnEnvMatch && !window.emui.cdnDomain) {
      window.emui.cdnDomain = `https://cdn.mortgagetech.${cdnEnvMatch[1]}.ice.com`;
    }
  } catch (e) {
    // env source unavailable; leave cdnDomain unset (pui-logrocket default)
  }
  window.emui.brumConfig = window.emui.brumConfig || {};
  window.emui.brumConfig.appKey = 'AD-AAB-AAX-BGS'; // ToDo: Replace this with your AppDynamics id
  window.emui.brumConfig.beaconUrlHttp = 'http://pdx-col.eum-appdynamics.com';
  window.emui.brumConfig.beaconUrlHttps = 'https://pdx-col.eum-appdynamics.com';
  window.emui.brumConfig.customData = function customData() {
    return { userData: { 'sub-app-id': 'ppe-partner-ui' } }; // ToDo: Replace this with your micro app id
  };

  // google tag manager
  // const gtmAuth = 'jTKqZUn8jotP4jqNcy6kVA'; // ToDo: Replace this with your Google Tag Manager environment auth code
  // const gtmEnv = 'env-3'; // ToDo: Replace this with your Google Tag Manager environment id
  // const gtmId = 'GTM-5QSFTSC'; // ToDo: Replace this with your Google Tag Manager container id
  // window.gtmDataLayer = [];

  // // eslint-disable-next-line max-params
  // const initGTM = (w, d, s, l, i) => {
  //   w[l] = w[l] || [];
  //   w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  //   const f = d.getElementsByTagName(s)[0];
  //   const j = d.createElement(s);
  //   const dl = l !== 'dataLayer' ? `&l=${l}` : '';
  //   j.async = true;
  //   j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}&gtm_auth=${gtmAuth}&gtm_preview=${gtmEnv}&gtm_cookies_win=x`;
  //   f.parentNode.insertBefore(j, f);
  // };
  // initGTM(window, document, 'script', 'gtmDataLayer', gtmId);

  let appWindow = window;
  try {
    // eslint-disable-next-line no-unused-expressions
    window.parent.document;
    appWindow = window.parent;
    // eslint-disable-next-line no-empty
  } catch (ex) {}
  window.emui.version = (appWindow.emui && appWindow.emui.version) || 'latest';

  // logger
  const { logger, http, logUnhandledErrors, webvitals } =
    window.emuiDiagnostics || {};
  if (logger) {
    // ToDo: Replace index, team, appName values
    window.emui.logger = logger({
      transport: http('https://int.api.ellielabs.com/diagnostics/v2/logging'),
      index: 'microfe',
      team: 'ICE PPE',
      appName: 'PPE Partner UI',
    });

    webvitals(window.emui.logger);
    logUnhandledErrors(window.emui.logger);
    window.emui.logger.info('application initialized');
  } else console.warn('diagnostics library missing'); // eslint-disable-line no-console
})();
